export const categoryIllustrations = {
  'Nombres': '🔢',
  'Verbes': '🏃‍♂️',
  'Animaux': '🐆',
  'Famille': '👨‍👩‍👧‍👦',
  'Corps': '🧑',
  'Couleurs': '🎨',
  'Nourriture': '🍞',
  'Temps': '📅',
  'Objets sacrés et du quotidien': '𓋹',
  'Divinités': '𓇳',
  'Villes': '🏛️',
  'Pharaons': '👑',
  'Plantes': '🌿',
  'Sur les murs des temples': '𓉐',
};

export default categoryIllustrations;
